import { gql } from '@apollo/client';

export const CONTENT_LIBRARY_ADD_CHILD = gql`
  mutation addChildMutation($id: String!, $key: String!, $child: ContentChildInput!) {
    addChild(id: $id, key: $key, child: $child)
  }
`;

export const CONTENT_LIBRARY_ADD_ITEM = gql`
  mutation addContentItem(
    $key: String
    $fromKey: String!
    $itemId: String
    $id: String
    $newTemplateName: String
    $newCatalogName: String
    $type: String!
    $createTemplate: Boolean
    $itemIds: [String!]
  ) {
    addItem(
      key: $key
      itemId: $itemId
      id: $id
      fromKey: $fromKey
      newTemplateName: $newTemplateName
      newCatalogName: $newCatalogName
      type: $type
      createTemplate: $createTemplate
      itemIds: $itemIds
    )
  }
`;

export const CONTENT_LIBRARY_DELETE_CHILD = gql`
  mutation deleteChildMutation($id: String!, $key: String!) {
    deleteChild(id: $id, key: $key)
  }
`;

// export const CONTENT_LIBRARY_DELETE_ITEM = gql`
//   mutation addItemMutation($id: String!, $key: String!) {
//     addItem(id: $id, key: $key)
//   }
// `;

export const CONTENT_LIBRARY_RENAME_CHILD = gql`
  mutation addItemMutation($id: String!, $key: String!, $name: String!) {
    renameChild(id: $id, key: $key, name: $name)
  }
`;

export const UPDATE_CONTENT_LIBRARY = gql`
  mutation updateContentItemMutation($id: String!, $type: String!, $item: ContentItemInput!) {
    updateContentItem(id: $id, type: $type, item: $item)
  }
`;

export const UPLOAD_AND_ATTACH_THUMBNAIL = gql`
  mutation ($thumbnailUrl: String!, $id: String!, $type: String!) {
    uploadAndAttachThumbnail(thumbnailUrl: $thumbnailUrl, id: $id, type: $type)
  }
`;

export const ADD_LIBRARY_COVER = gql`
  mutation ($cover: CoverInput!, $folderKey: String!) {
    addLibraryCover(cover: $cover, folderKey: $folderKey)
  }
`;

export const ADD_LIBRARY_MEDIA = gql`
  mutation ($media: MediaInput!, $folderKey: String!) {
    addLibraryMedia(media: $media, folderKey: $folderKey)
  }
`;

export const ADD_LIBRARY_SECTION = gql`
  mutation ($section: LibraryInput!, $folderKey: String!, $language: String!, $isHeader: Boolean) {
    addLibrarySection(
      section: $section
      folderKey: $folderKey
      language: $language
      isHeader: $isHeader
    )
  }
`;

// Autosave: dot-path partial updates (draft.header.raw, etc.)
export const UPDATE_PARTIAL_LIBRARY_TEMPLATE_MUTATION = gql`
  mutation ($topic: String!, $template: PartialTemplateInput!) {
    updatePartialTemplate(topic: $topic, template: $template) {
      _id
      edited
    }
  }
`;

// Full save: restore, offline sync, multi-field wizard updates
export const UPDATE_LIBRARY_TEMPLATE_MUTATION = gql`
  mutation ($template: TemplatesInput!, $topic: String!) {
    updateTemplate(topic: $topic, template: $template) {
      _id
      edited
    }
  }
`;

// Restore from backup: needs full draft returned from server
export const UPDATE_LIBRARY_TEMPLATE_RESTORE_MUTATION = gql`
  mutation ($template: TemplatesInput!, $topic: String!) {
    updateTemplate(topic: $topic, template: $template) {
      _id
      pid
      uid
      auid
      edited
      state
      draft
      client {
        contact
        name
        desc
        address
        text
        email
      }
      project {
        name
        type
        othertype
        desc
        goals
      }
      hubspot {
        hubspotObjectType
        hubspotContactId
        hubspotDealId
        hubspotCompanyId
      }
      pricing
      deliverables
      milestones
      contactOptions {
        option
        value
        enabled
      }
      expiryDate
      expiryMessage
      currency
      language
      curr
      decimalPrecision
      priceSeperator
      contactnumber
      disableSig
      published
      prevState
      templateName
      templateUrl
      wixTemplateId
      editEvent
      enableAITool
    }
  }
`;

export const UPDATE_LIBRARY_SECTION_MUTATION = gql`
  mutation ($section: LibraryInput!) {
    updateLibrary(section: $section) {
      _id
      title
      uid
      auid
      libraryTitle
      subtitle
      raw
      raw1
      raw2
      raw3
      subrawtitle
      rawtitle
      text
      starred
      createdAt
      thumbnail
      language
      isHeader
      by
      color
      contact
      cover
      email
      logo
      name
      rawby
      rawcontact
      rawemail
      rawname
      rawsubtitle
      titleStyle
      clientname
      originalState
      headerConfig
      hidecover
      sectionStyles
      titleFont
      subTitleFont
      bodyFont
    }
  }
`;

export const CONTENT_LIBRARY_SECTION_DELETE = gql`
  mutation ($_id: String!, $folderKey: String) {
    deleteLibrary(_id: $_id, folderKey: $folderKey)
  }
`;

export const CONTENT_LIBRARY_TEMPLATE_DELETE = gql`
  mutation ($_id: String!, $folderKey: String) {
    deleteTemplate(_id: $_id, folderKey: $folderKey)
  }
`;

export const CONTENT_LIBRARY_COVERS_DELETE = gql`
  mutation ($_id: String!, $folderKey: String) {
    deleteCover(_id: $_id, folderKey: $folderKey)
  }
`;

export const CONTENT_LIBRARY_MEDIA_DELETE = gql`
  mutation ($_id: String!, $folderKey: String) {
    deleteMedia(_id: $_id, folderKey: $folderKey)
  }
`;

export const CONTENT_LIBRARY_CATALOG_DELETE = gql`
  mutation ($_id: String, $folderKey: String, $_ids: [String!]) {
    deleteCatalog(_id: $_id, folderKey: $folderKey, _ids: $_ids)
  }
`;

export const CONTENT_LIBRARY_ADD_CATALOG = gql`
  mutation addCatalog($catalog: CatalogInput!) {
    addCatalog(catalog: $catalog)
  }
`;

export const CONTENT_LIBRARY_UPDATE_CATALOG = gql`
  mutation updateCatalog($id: String!, $catalog: CatalogInput!) {
    updateCatalog(id: $id, catalog: $catalog)
  }
`;

export const ADD_CATALOG_PRODUCTS = gql`
  mutation addCatalogProducts($products: [CatalogProductInput!]!, $folderKey: String!) {
    addCatalogProducts(products: $products, folderKey: $folderKey)
  }
`;

export const PARSE_XML_CATALOG = gql`
  mutation parseXMLCatalog($xmlUrl: String!) {
    parseXMLCatalog(xmlUrl: $xmlUrl) {
      name
      description
      quantity
      price {
        amount
        type
        quantity
        items
      }
      discount {
        value
        unit
      }
      tax {
        value
        unit
      }
      images {
        url
        name
      }
      paymentType
      additionalFields
    }
  }
`;

export const SAVE_CATALOG_XML_LINK = gql`
  mutation saveCatalogXMLLink($xmlLink: CatalogXMLLinkInput!) {
    saveCatalogXMLLink(xmlLink: $xmlLink) {
      _id
    }
  }
`;

export const DELETE_CATALOG_XML_LINK = gql`
  mutation deleteCatalogXMLLink($_id: String!) {
    deleteCatalogXMLLink(_id: $_id)
  }
`;

export const SYNC_CATALOG_FROM_XML = gql`
  mutation syncCatalogFromXML($_id: String!) {
    syncCatalogFromXML(_id: $_id)
  }
`;

export const SYNC_CATALOG_FROM_XML_BACKGROUND = gql`
  mutation syncCatalogFromXMLBackground($_id: String!) {
    syncCatalogFromXMLBackground(_id: $_id)
  }
`;
